<template>
    <div class="page choose-hospital">

        <div class="search">
            <van-search v-model="value" clearable @focus="is_search = true" @clear="is_search = false" @input="onSearch"
                        placeholder="搜索添加更多医院"/>
        </div>

        <div class="choose-hospital-title">
            医院列表
        </div>

        <div class="choose-hospital-content">
            <van-radio-group v-model="radio" v-if="value != ''" checked-color="#d3172e">
                <van-list :border="false">
                    <van-cell clickable @click="changeSearch(index)" v-for="(item,index) in search_hospital"
                              :key="index">
                        <template slot="title">
                            <span class="choose-hospital-content-title" v-html="item.light_name"></span>
                        </template>
                    </van-cell>
                    <van-cell clickable @click="addHospital">
                        <template slot="title">
                            <span class="choose-hospital-content-title">
                                <img src="/static/img/login/icon_login_add.svg" alt=""> 添加医院“{{value}}”
                            </span>
                        </template>
                    </van-cell>
                </van-list>
            </van-radio-group>
            <van-radio-group v-model="radio" v-if="value == ''" checked-color="#d3172e">
                <van-list
                    :finished="finished"
                    @load="more_hospital"
                    finished-text="已到底部"
                    :border="false">
                    <van-cell clickable @click="change(index)" v-for="(item,index) in hospital" :key="index">
                        <template slot="icon">
                            <van-radio :name="index"/>
                        </template>
                        <template slot="title">
                            <span class="choose-hospital-content-title" v-html="item.name"></span>
                        </template>
                    </van-cell>
                </van-list>
            </van-radio-group>
        </div>

        <div class="choose-hospital-confirm">
            <van-cell class="choose-hospital-confirm-cell">
                <template slot="title">
                    <div class="choose-hospital-confirm-left">已选：</div>
                    <div class="choose-hospital-confirm-content">{{formData.hospital}}</div>
                    <van-button class="choose-hospital-confirm-btn" type="danger" @click="chooseHospital()"
                                color="#0FB7AD" round size="small">确定
                    </van-button>
                </template>
            </van-cell>
        </div>

    </div>
</template>

<script>

    import Interface from "@/util/interface"

    export default {
        name: 'home',
        data() {
            return {
                value: "",
                radio: "",
                hospital: [],
                search_hospital: [],
                formData: {},
                is_search: false,
                page: 1,
                pageSize: 30,
                finished: false,
                loading: false,
                total_page: 1,
                patientsIndex:null,
            }
        },
        methods: {
            onSubmit() {
            },
            onSearch() {
                let params = {
                    pageSize: 999,
                    name: this.value
                }
                Interface.getData('get', Interface.user.hospital_search, params).then((res) => {
                    this.search_hospital = res.data
                    this.search_hospital.forEach((item,index) => {
                        if(item.name == this.value){
                            this.radio = index
                        }
                    })
                })
            },
            addHospital() {
                this.formData.city_id = 424;
                Interface.getData('post', Interface.user.hospital, {
                    name: this.value,
                    // city_id: this.formData.city_id
                }).then((res) => {
                    if (res.code == 0) {
                        this.radio = 0
                        this.formData.hospital_id = res.data.id
                        this.formData.hospital = this.value
                        this.$toast.success("添加成功")
                        this.onSearch()
                    } else {
                        this.$toast.fail(res.message)
                    }
                })
            },
            fetch(scene) {
                if (scene === 'hospital') {
                    let params = {
                        page: this.page,
                        pageSize: this.pageSize,
                    }
                    this.loading = true
                    Interface.getData('get', Interface.user.hospital, params).then((res) => {
                        this.hospital.push(...res.data.list)
                        this.init();
                        this.loading = false
                        if (this.page == res.data.total_page) {
                            this.finished = true
                        }
                    })
                }
            },
            more_hospital() {
                if (this.loading) {
                    return
                }
                this.page += 1
                this.fetch('hospital')
            },
            chooseHospital() {
                let patientsIndex = sessionStorage.getItem('add-info-patients-index')
                console.log("patientsIndex",patientsIndex)
                if (patientsIndex !== null) {
                    let formData = JSON.parse(sessionStorage.getItem('add-info'))
                    if (this.is_search) {
                        formData.patients[patientsIndex].hospital = this.search_hospital[this.radio].name
                        formData.patients[patientsIndex].hospital_name = this.search_hospital[this.radio].name
                        formData.patients[patientsIndex].hospital_id = this.search_hospital[this.radio].id
                    } else {
                        formData.patients[patientsIndex].hospital = this.hospital[this.radio].name
                        formData.patients[patientsIndex].hospital_name = this.hospital[this.radio].name
                        formData.patients[patientsIndex].hospital_id = this.hospital[this.radio].id
                    }
                    sessionStorage.setItem('add-info', JSON.stringify(formData))
                    this.$router.push({
                        name: "add-info",
                    })
                } else {
                    let formData = JSON.parse(sessionStorage.getItem('add-info'))
                    if (this.is_search) {
                        formData.hospital = this.search_hospital[this.radio].name
                        formData.hospital_name = this.search_hospital[this.radio].name
                        formData.hospital_id = this.search_hospital[this.radio].id
                    } else {
                        formData.hospital = this.hospital[this.radio].name
                        formData.hospital_name = this.hospital[this.radio].name
                        formData.hospital_id = this.hospital[this.radio].id
                    }
                    sessionStorage.setItem('add-info', JSON.stringify(formData))
                    this.$router.push({
                        name: "add-info",
                    })
                }
            },
            change(index) {
                this.radio = index
                this.formData.hospital = this.hospital[this.radio].name
            },
            changeSearch(index) {
                this.radio = index
                this.formData.hospital = this.search_hospital[this.radio].name
            },
            init() {
                if (this.hospital.length > 0) {
                    this.hospital.forEach((val, index) => {
                        if(this.patientsIndex !== null){
                            if (val.id == this.formData.patients[this.patientsIndex].hospital_id) {
                                this.radio = index
                                this.formData.hospital = val.name
                            }
                        }else{
                            if (val.id == this.formData.hospital_id) {
                                this.radio = index
                                this.formData.hospital = val.name
                            }
                        }
                    })
                }
            }
        },
        created() {
            this.formData = {}
            let formData = JSON.parse(sessionStorage.getItem('add-info'))
            if (formData !== null) {
                this.formData = formData
            }
            Interface.getShareInfo(this, "", "", "")
            this.radio = ""
            this.value = ""

            let patientsIndex = sessionStorage.getItem('add-info-patients-index')
            if (patientsIndex !== null) {
                this.patientsIndex = patientsIndex
            }
            this.fetch('hospital')
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/choose-hospital/index.vue